<template>
  <div
    :class="[
      'puzzle mt-4',
      {
        'print-answer': showAnswer,
        'print-question': showQuestion,
        'puzzle-border-radius': settings.puzzleTypeStyle === 'radius',
        'puzzle-font-times': settings.puzzleTypeStyle === 'times',
        'puzzle-font-default': settings.puzzleTypeStyle === 'square',
      },
    ]"
    :style="{
      'grid-template-rows': `repeat(${rows}, ${cellSize}px)`,
      'grid-template-columns': `repeat(${columns}, ${cellSize}px)`,
    }"
  >
    <puzzle-cell
      ref="puzzleCell"
      v-for="(cell, index) in table"
      :key="`${cell.positiony}-${cell.positionx}`"
      :cell="cell"
      :data-index="index"
      :template-mode="templateMode"
      :is-planning-mode="canEditQuestions"
      :class="{ 'is-thinking': isGenerating && isCurrentScan(cell) }"
    />
  </div>
</template>

<script>
import PuzzleCell from './PuzzleCell.vue';

export default {
  name: 'PuzzleGrid',
  components: { PuzzleCell },
  props: {
    table: Array,
    rows: [Number, String],
    columns: [Number, String],
    settings: Object,
    cellSize: Number,
    showAnswer: Boolean,
    showQuestion: Boolean,
    templateMode: Boolean,
    canEditQuestions: Boolean,
    isGenerating: Boolean,
    activeScanCell: Object,
  },
  methods: {
    isCurrentScan(cell) {
      return (
        Number(cell.positionx) === this.activeScanCell?.x &&
        Number(cell.positiony) === this.activeScanCell?.y &&
        !cell.isQuestion
      );
    },
    reRenderCells() {
      if (this.$refs.puzzleCell) {
        this.$refs.puzzleCell.forEach(cell => cell.reRender?.());
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/puzzle';
.is-thinking {
  background-color: #E0E0E0 !important;
  border: 1px solid #BDBDBD !important;
  box-shadow: inset 0 0 8px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.1s ease-in-out;
  z-index: 5;
  animation: pulse-gray 1.5s infinite ease-in-out;
}

@keyframes pulse-gray {
  0% { background-color: #E0E0E0; }
  50% { background-color: #F5F5F5; }
  100% { background-color: #E0E0E0; }
}
</style>
